import { GeneralProvider } from './context/GeneralContext';
import { BrowserRouter as Router } from 'react-router-dom';
import AnimatedRoutes from './components/AnimatedRoutes';

function App() {
  return (
    <GeneralProvider>
      <Router>
        <AnimatedRoutes />
      </Router>
    </GeneralProvider>
  );
}

export default App;
